import React, { FC } from 'react'
import SbEditable from 'storyblok-react'
import { ComponentProps, Resolver } from '..'
import { GridContainer, GridItem, GridWrapper } from './styles'

interface GridProps {
  content: any
  sm: number
  md: number
  lg: number
  xl: number
  xs: number
  collapse_margin: boolean
}

export const Grid: FC<ComponentProps<GridProps>> = ({ blok }) => {
  const { _uid, content, sm, md, lg, xl, xs, collapse_margin } = blok

  return (
    <SbEditable content={blok} key={_uid}>
      <GridWrapper>
        <GridContainer collapse={collapse_margin}>
          {content
            ? content.map((child) => (
                <GridItem
                  key={child._uid}
                  sizes={{
                    xs: 1 / xs,
                    sm: 1 / sm,
                    md: 1 / md,
                    lg: 1 / lg,
                    xl: 1 / xl,
                  }}
                >
                  <Resolver blok={child} />
                </GridItem>
              ))
            : null}
        </GridContainer>
      </GridWrapper>
    </SbEditable>
  )
}
